import React, { useState } from "react";
import Minus from "images/Minus.svg";
import Plus from "images/Plus.svg";
import NcImage from "images/FAQ.png";

interface SectionProps {
  title: string;
  children: React.ReactNode;
  isOpen: boolean;
  onToggle: () => void;
}

const Section: React.FC<SectionProps> = ({
  title,
  children,
  isOpen,
  onToggle,
}) => {
  return (
    <div className=" my-4 bg-[#FFFFFF1A] rounded-xl px-6">
      <button
        onClick={onToggle}
        className="flex justify-between w-full space-x-4 px-4 py-6 text-left items-center"
      >
        <span className="text-lg font-semibold leading-7 text-left text-[#FFFFFF]">
          {title}
        </span>
        <span>
          {isOpen ? (
            <svg
              width="15"
              height="4"
              viewBox="0 0 15 4"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.1 0.5C13.6312 0.5 14.1 0.96875 14.1 1.5V2.5C14.1 3.0625 13.6312 3.5 13.1 3.5H1.1C0.5375 3.5 0.0999999 3.0625 0.0999999 2.5V1.5C0.0999999 0.96875 0.5375 0.5 1.1 0.5H13.1Z"
                fill="white"
              />
            </svg>
          ) : (
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.9 6.37988C1.36875 6.37988 0.9 6.84863 0.9 7.37988V8.37988C0.9 8.94238 1.36875 9.37988 1.9 9.37988H6.4V13.8799C6.4 14.4424 6.86875 14.8799 7.4 14.8799H8.4C8.9625 14.8799 9.4 14.4424 9.4 13.8799V9.37988H13.9C14.4625 9.37988 14.9 8.94238 14.9 8.37988V7.37988C14.9 6.84863 14.4625 6.37988 13.9 6.37988H9.4V1.87988C9.4 1.34863 8.9625 0.879883 8.4 0.879883H7.4C6.86875 0.879883 6.4 1.34863 6.4 1.87988V6.37988H1.9Z"
                fill="white"
              />
            </svg>
          )}
        </span>
      </button>
      {isOpen && <div className="px-4 py-2">{children}</div>}
    </div>
  );
};

const RentalPolicies: React.FC = () => {
  const [openSectionIndex, setOpenSectionIndex] = useState<number | null>(null);

  const handleToggle = (index: number) => {
    setOpenSectionIndex(openSectionIndex === index ? null : index);
  };
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 items-center">
      <div className="flex flex-col space-y-10 justify-center mb-16">
        <span className="text-5xl   font-semibold text-left">
          Frequently Asked Questions
        </span>
        <span className="text-xl  font-normal text-left">
          DO have any kind Of questions? We're here to help.
        </span>
        <img className="" src={NcImage} alt="" />
      </div>
      <div className=" ">
        <Section
          title="What is the minimum age requirement for renting?"
          isOpen={openSectionIndex === 1}
          onToggle={() => handleToggle(1)}
        >
          <span className="text-base font-normal leading-6 text-left text-[#92939E]">
            You must be 18 or older with a valid drivers license to rent.
          </span>
        </Section>

        <Section
          title="Is there a security deposit needed for rentals?"
          isOpen={openSectionIndex === 3}
          onToggle={() => handleToggle(3)}
        >
          <span className="text-base font-normal leading-6 text-left text-[#92939E]">
            There’s a security deposit of $175, the security deposit is for gas,
            smoking and cleaning. If any of these things are violated, you’ll be
            charged.
          </span>
        </Section>
        <Section
          title=" Is there a minimum rental duration?"
          isOpen={openSectionIndex === 4}
          onToggle={() => handleToggle(4)}
        >
          <span className="text-base font-normal leading-6 text-left text-[#92939E]">
            Yes, our minimum rental period is 24 hours.
          </span>
        </Section>
        <Section
          title="Do I need my own auto insurance to rent?"
          isOpen={openSectionIndex === 5}
          onToggle={() => handleToggle(5)}
        >
          <span className="text-base font-normal leading-6 text-left text-[#92939E]">
            You do not need your own insurance. It is a requirement to purchase
            insurance.
          </span>
        </Section>
      </div>
    </div>
  );
};

export default RentalPolicies;
